import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  AlertTitle
} from '@mui/material';
import { useApp } from '../../context/AppContext';

const AlertDialog = () => {
  const { state, actions } = useApp();

  const handleClose = () => {
    actions.hideAlert();
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'success':
        return 'success';
      case 'info':
      default:
        return 'info';
    }
  };

  const getSeverityTitle = (severity) => {
    switch (severity) {
      case 'error':
        return 'Error';
      case 'warning':
        return 'Warning';
      case 'success':
        return 'Success';
      case 'info':
      default:
        return 'Information';
    }
  };

  return (
    <Dialog
      open={state.alert.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogContent sx={{ p: 0 }}>
        <Alert 
          severity={getSeverityColor(state.alert.severity)}
          sx={{ 
            '& .MuiAlert-message': { width: '100%' },
            borderRadius: 0
          }}
        >
          <AlertTitle>{getSeverityTitle(state.alert.severity)}</AlertTitle>
          {state.alert.message}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog; 